import React from "react";
import { Icon, Menu } from "semantic-ui-react";
import PrescriptionsTab from "./tabs/PrescriptionsTab";
import PrescriptionsContent from "./content/PrescriptionsContent";
//import IdentityCheckContent from "./content/IdentityCheckContent";
import QuestionsContent from "./content/QuestionsContent";
import TubesContent from "./content/TubesContent";
import AliquotsContent from "./content/AliquotsContent";
//import DocumentsContent from "./content/DocumentsContent";
import HistoricalContent from "./content/HistoricalContent";
import GeslabWarningContent from "./content/GeslabWarningContent";
//import ExternalsContent from "./content/ExternalsContent";
import ResultContent from "./content/ResultContent";
//import IdentityCheckTab from "./tabs/IdentityCheckTab";
import QuestionsTab from "./tabs/QuestionsTab";
import TubesTab from "./tabs/TubesTab";
import AliquotsTab from "./tabs/AliquotsTab";
//import DocumentsTab from "./tabs/DocumentsTab";
import HistoricalTab from "./tabs/HistoricalTab";
import GeslabWarningTab from "./tabs/GeslabWarningTab";
//import ExternalsTab from "./tabs/ExternalsTab";
import ResultTab from "./tabs/ResultTab";
//import IdentityCheckModal from "./modals/IdentityCheckModal";
import MotivationsTab from "./tabs/MotivationsTab";
import EndotestTab from "./tabs/EndotestTab";
import EndotestContent from "./content/EndotestContent";
import DepositTab from "./tabs/DepositTab";
import DepositContent from "./content/DepositContent";
import "styles/tabs.css";

const getPanesData = ({
	t,
	disabled,
	prescriptionInfo,
	mode,
	role,
	data,
	generalParameters,
	folderManager,
	isMobile,
	folder,
	sendFilesToDualScreen,
	sendFullScanListToDualScreen,
	validateQualityScanPrescription,
	unvalidateQualityScanPrescription,
	validateScanPrescription,
	validationLoading,
	openGranteeModal,
	hideSidebar,
	deletePrescription,
	openPrescriptionScanModal,
	editPrescription,
	openSidebar,
	openScanOrdo,
	dualScreen,
	addPrescription,
	openAddRepeatablePrescriptionModal,
	openQRReaderPrescriptionModal,
	getFPA,
	useScanOrdo,
	removeScanOrdo,
	loadingScans,
	addAutoScanLogs,
	center,
	postPhotoFolder,
	consentRefusalReasons,
	getAllConsentRefusalReasons,
	getAllDocumentTypes,
	documentTypes,
	groupByDocumentType,
	bulkAnalysesPrescription,
	getMatchingAnalyses,
	editAnalyses,
	getPrescriptionByBarcode,
	postScanPrescription,
	loadAllAnalysesAndPacks,
	analysisLibrary,
	updateScanPrescription,
	createFolderHelpAndQuit,
	cleanScans,
	tvSecScans,
	openEditPatient,
	setPrescriptionScanBarcode,
	deleteScanPrescription,
	connectedSecretariesList,
	formStatus,
	formMotivationStatus,
	questionAnswersSaved,
	questionErrors,
	aliquotsErrors,
	aliquotStatus,
	missingVolumeTubes,
	resultStatus,
	tubeStatus,
	tubeErrors,
	onQuestionsSubmit,
	onMotivationsSubmit,
	user,
	setFormStatus,
	setQuestionErrors,
	setMotivationsErrors,
	prevalidFolders,
	setFormikRef,
	formikRef,
	setQuestionsDataToUpdate,
	questionsDataToUpdate,
	patchUntakenTube,
	getAllTubeUntakenReasons,
	submitAddTubeModal,
	openDeleteNotPrescribedTubeConfirm,
	patchMultipleTubes,
	loadAddTubeModalData,
	patchTubeSamplingTime,
	cancelReuseTube,
	getReusableTubes,
	getAllTubeNatureReasons,
	patchTubeNature,
	getMissingVolumeTubes,
	submitDeleteNotPrescribedTubeConfirm,
	tubeReducer,
	saveSafeplaceResult,
	activeTabIndex,
	logs,
	patchGeslabAlert,
	geslabAlert,
	identityModalOpen,
	toggleIdentityModal,
	getFolderLogs,
	checkIdentity,
	openContactModal,
	motivationsSaved,
	motivationsErrors,
	endoStatus,
	endoErrors,
	putEndoAnswers,
	saveDeposit,
	refuseAnalysis,
	showDeposit,
	depositPlaces,
	depositSamplers,
	depositErrors,
	isThemeHospital,
	getScansForTVsecretariat,
	refreshCenterScans,
	checkAnalysis,
	toggleContact,
}) => {
	const tabStyle = (error, active, warning = false) =>
		isMobile()
			? {
					backgroundColor: !disabled && error ? "#ffa5a36e" : warning ? "#f2711c45" : "transparent",
					fontSize: 15,
					border: active ? "2px solid #00917d" : "1px solid #87878757",
					color: active ? "#00917d" : "#878787",
					borderRadius: 0,
			  }
			: {
					height: 40,
					backgroundColor: !disabled && error ? "#ffa5a3" : warning ? "#f2711c45" : "transparent",
					color: active ? "#00917d" : "#878787",
					fontWeight: active ? 600 : 400,
					borderRadius: 0,
					border: 0,
					borderBottom: active ? "2px solid #00917d" : "0",
					padding: "0 10px",
					fontSize: 14,
			  };

	const menuPrescription = {
		menuItem: (
			<Menu.Item
				key="prescriptions"
				style={tabStyle(
					!prescriptionInfo.status,
					activeTabIndex === "prescriptions",
					prescriptionInfo.othersWarnings && Object.keys(prescriptionInfo.othersWarnings).length > 0
				)}
			>
				<PrescriptionsTab t={t} disabled={disabled} prescription={prescriptionInfo} />
			</Menu.Item>
		),
		render: () => (
			<PrescriptionsContent
				t={t}
				disabled={disabled}
				data={data}
				mode={mode}
				role={role}
				generalParameters={generalParameters}
				folderManager={folderManager}
				isMobile={isMobile}
				folder={folder}
				dualScreen={dualScreen}
				openScanOrdo={openScanOrdo}
				userIsSecretary={role === "SECRETARY"}
				sendFilesToDualScreen={sendFilesToDualScreen}
				sendFullScanListToDualScreen={sendFullScanListToDualScreen}
				openSidebar={openSidebar}
				editPrescription={editPrescription}
				openPrescriptionScanModal={openPrescriptionScanModal}
				deletePrescription={deletePrescription}
				hideSidebar={hideSidebar}
				openGranteeModal={openGranteeModal}
				validationLoading={validationLoading}
				validateScanPrescription={validateScanPrescription}
				validateQualityScanPrescription={validateQualityScanPrescription}
				unvalidateQualityScanPrescription={unvalidateQualityScanPrescription}
				deleteScanPrescription={deleteScanPrescription}
				setPrescriptionScanBarcode={setPrescriptionScanBarcode}
				openEditPatient={openEditPatient}
				tvSecScans={tvSecScans}
				cleanScans={cleanScans}
				createFolderHelpAndQuit={createFolderHelpAndQuit}
				updateScanPrescription={updateScanPrescription}
				analysisLibrary={analysisLibrary}
				loadAllAnalysesAndPacks={loadAllAnalysesAndPacks}
				postScanPrescription={postScanPrescription}
				getPrescriptionByBarcode={getPrescriptionByBarcode}
				editAnalyses={editAnalyses}
				getMatchingAnalyses={getMatchingAnalyses}
				bulkAnalysesPrescription={bulkAnalysesPrescription}
				groupByDocumentType={groupByDocumentType}
				documentTypes={documentTypes}
				getAllDocumentTypes={getAllDocumentTypes}
				getAllConsentRefusalReasons={getAllConsentRefusalReasons}
				consentRefusalReasons={consentRefusalReasons}
				postPhotoFolder={postPhotoFolder}
				center={center}
				addAutoScanLogs={addAutoScanLogs}
				connectedSecretariesList={connectedSecretariesList}
				loadingScans={loadingScans}
				removeScanOrdo={removeScanOrdo}
				useScanOrdo={useScanOrdo}
				getFPA={getFPA}
				openQRReaderPrescriptionModal={openQRReaderPrescriptionModal}
				openAddRepeatablePrescriptionModal={openAddRepeatablePrescriptionModal}
				addPrescription={addPrescription}
				openContactModal={openContactModal}
				refuseAnalysis={refuseAnalysis}
				isThemeHospital={isThemeHospital}
				getScansForTVsecretariat={getScansForTVsecretariat}
				refreshCenterScans={refreshCenterScans}
				checkAnalysis={checkAnalysis}
				toggleContact={toggleContact}
			/>
		),
	};
	/* const menuIdentityCheck = {
		menuItem: (
			<Menu.Item key="identityCheck" style={tabStyle(false, activeTabIndex === "identityCheck")}>
				<IdentityCheckTab t={t} onClick={() => toggleIdentityModal()} />
				<IdentityCheckModal
					open={identityModalOpen}
					close={() => toggleIdentityModal()}
					folder={folder}
					patient={data.patient}
					checkIdentity={checkIdentity}
					identity={data.infos.identity}
					disabled={disabled}
					errors={data.infos.identityCheckErrors}
				/>
			</Menu.Item>
		),
		render: () => <IdentityCheckContent t={t} />,
	}; */
	const menuMotivations = {
		menuItem: (
			<Menu.Item key="motivations" style={tabStyle(!(formMotivationStatus && motivationsSaved), activeTabIndex === "motivations")}>
				<MotivationsTab t={t} motivationsSaved={motivationsSaved} motivationsErrors={motivationsErrors} />
			</Menu.Item>
		),
		render: () => (
			<QuestionsContent
				t={t}
				mode={mode}
				disabled={disabled}
				data={data}
				userIsSecretary={role === "SECRETARY"}
				onQuestionsSubmit={onQuestionsSubmit}
				user={user}
				setFormStatus={setFormStatus}
				setQuestionErrors={setQuestionErrors}
				questionsDataToUpdate={questionsDataToUpdate}
				setQuestionsDataToUpdate={setQuestionsDataToUpdate}
				isForMotivationContent={true}
				setMotivationsErrors={setMotivationsErrors}
			/>
		),
	};

	const menuQuestions = {
		menuItem: (
			<Menu.Item key="questions" style={tabStyle(!(formStatus && questionAnswersSaved), activeTabIndex === "questions")}>
				<QuestionsTab t={t} formStatus={formStatus} questionAnswersSaved={questionAnswersSaved} questionErrors={questionErrors} />
			</Menu.Item>
		),
		render: () => (
			<QuestionsContent
				t={t}
				mode={mode}
				disabled={disabled}
				data={data}
				userIsSecretary={role === "SECRETARY"}
				onQuestionsSubmit={onQuestionsSubmit}
				user={user}
				setFormStatus={setFormStatus}
				setQuestionErrors={setQuestionErrors}
				prevalidFolders={prevalidFolders}
				openSidebar={openSidebar}
				formStatus={formStatus}
				formikRef={formikRef}
				setFormikRef={setFormikRef}
				setQuestionsDataToUpdate={setQuestionsDataToUpdate}
				questionsDataToUpdate={questionsDataToUpdate}
				isForMotivationContent={false}
				setMotivationsErrors={setMotivationsErrors}
			/>
		),
	};
	const menuEndoTest = {
		menuItem: (
			<Menu.Item key="endo" style={tabStyle(!endoStatus, activeTabIndex === "endo")}>
				<EndotestTab t={t} endoErrors={endoErrors} endoStatus={endoStatus} />
			</Menu.Item>
		),
		render: () => <EndotestContent data={data} putEndoAnswers={putEndoAnswers} />,
	};
	const menuTubes = {
		menuItem: (
			<Menu.Item key="tubes" style={tabStyle(!tubeStatus, activeTabIndex === "tubes")}>
				<TubesTab t={t} tubeErrors={tubeErrors} tubeStatus={tubeStatus} missingVolumeTubes={missingVolumeTubes} />
			</Menu.Item>
		),
		render: () => (
			<TubesContent
				t={t}
				data={data}
				disabled={disabled}
				user={user}
				generalParameters={generalParameters}
				patchUntakenTube={patchUntakenTube}
				getAllTubeUntakenReasons={getAllTubeUntakenReasons}
				submitAddTubeModal={submitAddTubeModal}
				openDeleteNotPrescribedTubeConfirm={openDeleteNotPrescribedTubeConfirm}
				patchMultipleTubes={patchMultipleTubes}
				loadAddTubeModalData={loadAddTubeModalData}
				patchTubeSamplingTime={patchTubeSamplingTime}
				cancelReuseTube={cancelReuseTube}
				getReusableTubes={getReusableTubes}
				getAllTubeNatureReasons={getAllTubeNatureReasons}
				patchTubeNature={patchTubeNature}
				getMissingVolumeTubes={getMissingVolumeTubes}
				submitDeleteNotPrescribedTubeConfirm={submitDeleteNotPrescribedTubeConfirm}
				tubeReducer={tubeReducer}
			/>
		),
	};
	const menuAliquots = {
		menuItem: (
			<Menu.Item key="aliquots" style={tabStyle(!aliquotStatus && aliquotsErrors.length > 0, activeTabIndex === "aliquots")}>
				<AliquotsTab t={t} aliquotsErrors={aliquotsErrors} aliquotStatus={aliquotStatus} missingVolumeTubes={missingVolumeTubes} />
			</Menu.Item>
		),
		render: () => (
			<AliquotsContent
				t={t}
				data={data}
				disabled={disabled}
				user={user}
				generalParameters={generalParameters}
				patchUntakenTube={patchUntakenTube}
				getAllTubeUntakenReasons={getAllTubeUntakenReasons}
				submitAddTubeModal={submitAddTubeModal}
				openDeleteNotPrescribedTubeConfirm={openDeleteNotPrescribedTubeConfirm}
				patchMultipleTubes={patchMultipleTubes}
				loadAddTubeModalData={loadAddTubeModalData}
				patchTubeSamplingTime={patchTubeSamplingTime}
				cancelReuseTube={cancelReuseTube}
				getReusableTubes={getReusableTubes}
				getAllTubeNatureReasons={getAllTubeNatureReasons}
				patchTubeNature={patchTubeNature}
				getMissingVolumeTubes={getMissingVolumeTubes}
				submitDeleteNotPrescribedTubeConfirm={submitDeleteNotPrescribedTubeConfirm}
				tubeReducer={tubeReducer}
				centerWithAliquots={data.infos.centerWithAliquots}
			/>
		),
	};
	const menuResults = {
		menuItem: (
			<Menu.Item key="results" style={tabStyle(resultStatus.result === "" || resultStatus.waiting.length > 0, activeTabIndex === "results")}>
				<ResultTab t={t} resultStatus={resultStatus} />
			</Menu.Item>
		),
		render: () => <ResultContent t={t} data={data} saveSafeplaceResult={saveSafeplaceResult} />,
	};
	/* 	const menuDocs = {
		menuItem: (
			<Menu.Item key="docs">
				<DocumentsTab t={t} />
			</Menu.Item>
		),
		render: () => <DocumentsContent t={t} />,
	}; */

	const menuDeposit = {
		menuItem: (
			<Menu.Item key="deposit" style={tabStyle(depositErrors.length > 0, activeTabIndex === "deposit")}>
				<DepositTab t={t} depositErrors={depositErrors} deposit={data.deposit} />
			</Menu.Item>
		),
		render: () => <DepositContent t={t} data={data} submit={saveDeposit} places={depositPlaces} samplers={depositSamplers} disabled={disabled} />,
	};
	const menuHisto = {
		menuItem: (
			<Menu.Item key="histo" style={tabStyle(false, activeTabIndex === "histo")} onClick={() => getFolderLogs(folder.id)}>
				<HistoricalTab t={t} />
			</Menu.Item>
		),
		render: () => <HistoricalContent logs={logs} />,
	};
	const menuGeslab = {
		menuItem: (
			<Menu.Item key="geslab" style={tabStyle(false, activeTabIndex === "geslab")}>
				<GeslabWarningTab t={t} geslabAlert={geslabAlert} />
			</Menu.Item>
		),
		render: () => <GeslabWarningContent t={t} data={data} patchGeslabAlert={patchGeslabAlert} />,
	};
	/* 	const menuExternals = {
		menuItem: (
			<Menu.Item key="externals" style={tabStyle(false, activeTabIndex === "externals")}>
				<ExternalsTab t={t} />
			</Menu.Item>
		),
		render: () => <ExternalsContent t={t} />,
	}; */
	let menu = [];
	if (showDeposit || data.deposit) menu.push(menuDeposit);
	menu.push(menuPrescription);
	//if (data.infos.hasIdentityToCheck) menu.push(menuIdentityCheck);
	if (
		data.questions.some(
			(q) =>
				q.questions.some((q) => q.question && q.question.motivation && q.question.sil_code !== "MARQTUM-M01" && q.question.code !== "MOT-PREGSERO") ||
				q.questions.some((q) => q.question.sil_code === "MARQTUM-M01" && q.links.reduce((sum, a) => sum + a.weight, 0) > 2) ||
				q.questions.some(
					(q) => data.patient.gender === "f" && q.question.code === "MOT-PREGSERO" && q.links.reduce((sum, a) => sum + a.weight, 0) > 12
				)
		)
	)
		menu.push(menuMotivations);
	if (role === "SECRETARY") {
		if (
			data.systematic_questions
				.concat(data.questions)
				.some((q) => q.questions.some((q) => q.question && !q.question.motivation && q.question.target !== "NURSE"))
		)
			menu.push(menuQuestions);
	}
	if (role === "NURSE") {
		if (data.systematic_questions.concat(data.questions).some((q) => q.questions.some((q) => !q.question.motivation))) menu.push(menuQuestions);
		if (data.prescriptions.some((p) => p.analyses && p.analyses.some((a) => a && a.properties && a.properties.code === "ENDO")))
			menu.push(menuEndoTest);
		if (data.tubes.length > 0) menu.push(menuTubes);
	}
	if (data.infos.hasAliquots) {
		if (data.isDone || (role === "NURSE" && !data.isDone && data.infos.centerWithAliquots > 0)) menu.push(menuAliquots);
	}
	if ((data.isDone || role === "NURSE") && data.tubes && data.tubes.some((t) => t.properties.timer_before_result > 0)) menu.push(menuResults);

	return menu.concat(isThemeHospital ? [] : [menuHisto, menuGeslab]);
};

export const CheckIcon = () => {
	return (
		<Icon
			className="greenIcon"
			size="small"
			name="checkmark"
			circular
			style={{
				position: "relative",
				bottom: 2,
				marginLeft: 3,
			}}
		/>
	);
};

export const WarningIcon = () => {
	return (
		<Icon
			className="warningIcon"
			size="small"
			name="warning"
			circular
			style={{
				position: "relative",
				bottom: 2,
				marginLeft: 3,
			}}
		/>
	);
};

export const WaitingIcon = () => {
	return (
		<Icon
			className="waitingIcon"
			size="small"
			name="wait"
			circular
			style={{
				position: "relative",
				bottom: 2,
				marginLeft: 3,
			}}
		/>
	);
};
export const AlertIcon = () => {
	return (
		<Icon
			className="warningIcon"
			size="small"
			name="warning sign"
			circular
			style={{
				position: "relative",
				bottom: 2,
				marginLeft: 3,
			}}
		/>
	);
};

export default getPanesData;
